// extracted by mini-css-extract-plugin
module.exports = {"passwordNote":"LoginPage_passwordNote__3wh5Z","hover-ripples":"LoginPage_hover-ripples__hdhzK"};